import request from '@/utils/request'

let FeedbackApi = {

  /*意见反馈列表*/
  list(data) {
    return request._post('/shop/plus.feedback.Index/index', data);
},
/*添加意见反馈*/
add(data) {
    return request._post('/shop/plus.feedback.Index/add', data);
},
/*修改意见反馈*/
edit(data) {
    return request._post('/shop/plus.feedback.Index/edit', data);
},
/*删除意见反馈*/
del(data) {
    return request._post('/shop/plus.feedback.Index/del', data);
},
/*意见反馈详情*/
detail(data) {
  return request._post('/shop/plus.feedback.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.feedback.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.feedback.Setting/getSetting', data, errorback);
    },
}
export default FeedbackApi;



// WEBPACK FOOTER //
// ./src/api/feedback.js